import script from "./RedesignMobileNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignMobileNotification.vue?vue&type=script&setup=true&lang=js"

import "./RedesignMobileNotification.vue?vue&type=style&index=0&id=0e3433c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3433c4"]])

export default __exports__